import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  callCreateShift,
  callDeleteShift,
  callDraftFinancialShiftDetail,
  callGetFinancialShiftDetail,
  callGetShift,
  callGetShiftDetail,
  callUpdateShift,
} from '../../helpers/api_helper';

export const getShift = createAsyncThunk('shift/callGetShift', async (param?: any) => {
  try {
    const response = callGetShift(param);
    return response;
  } catch (error) {
    return error;
  }
});

export const createShift = createAsyncThunk(
  'shift/callCreateShift',
  async (param: any, { rejectWithValue }) => {
    try {
      const response = callCreateShift(param);
      return response;
    } catch (error) {
      return rejectWithValue('Unexpected error');
    }
  },
);

export const editShift = createAsyncThunk(
  'shift/callUpdateShift',
  async (param: any, { rejectWithValue }) => {
    try {
      const response = callUpdateShift(param);
      return response;
    } catch (error) {
      return rejectWithValue('Unexpected error');
    }
  },
);

export const deleteShift = createAsyncThunk(
  'shift/callDeleteShift',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = callDeleteShift(id);
      return response;
    } catch (error) {
      return rejectWithValue('Unexpected error');
    }
  },
);

export const getShiftDetail = createAsyncThunk(
  'shift/getShiftDetail',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = callGetShiftDetail(id);
      return response;
    } catch (error) {
      return rejectWithValue('Unexpected error');
    }
  },
);

export const getFinancialShiftDetail = createAsyncThunk(
  'shift/callGetFinancialShiftDetail',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = callGetFinancialShiftDetail(id);
      return response;
    } catch (error) {
      return rejectWithValue('Unexpected error');
    }
  },
);

export const getDraftFinancialShiftDetail = createAsyncThunk(
  'shift/callDraftFinancialShiftDetail',
  async (payload: { id: string; payload?: any }, { rejectWithValue }) => {
    try {
      const response = callDraftFinancialShiftDetail(payload.id, payload.payload);
      return response;
    } catch (error) {
      return rejectWithValue('Unexpected error');
    }
  },
);
